import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { EntityQueryKey } from 'app/agriculture/queries/queryKey/useEntityQueryKey';
import {
    entityConfig,
    entityConfigToType,
    MutableEntityType,
} from 'app/agriculture/mutations/types/entityConfig';
import { z } from 'zod';
import { convertDatePropertiesToTZDate } from 'app/agriculture/queries/utils/convertDatePropertiesToTZDate';
import { handleZodParseError } from 'app/agriculture/utils';

export async function getEntities<T extends MutableEntityType>({
    queryKey: [entityType, { farm_id, timeZone }],
}: {
    queryKey: EntityQueryKey<T>;
}) {
    const { endpoint, schema } = entityConfig[entityType];

    const instance = createAxiosInstance();

    const { data } = await instance.get<T>(endpoint, {
        params: { farm_id },
    });

    try {
        return new Map(
            z
                .array(schema.transform((data) => convertDatePropertiesToTZDate(data, timeZone)))
                .parse(data)
                .map((entity) => [entity.id, entity]),
        ) as Map<entityConfigToType[T]['id'], entityConfigToType[T]>;
    } catch (e) {
        handleZodParseError(e);
        throw e;
    }
}
